import type { ReactElement } from 'react';

function Header(): ReactElement {
  return (
    <header data-testid="header" className="header-container">
      <img
        src="/assets/images/trybe-logo.svg"
        alt="Logo da Trybe"
        className="header-container__image"
        width="50%"
        height="50%"
        style={{ margin: '1rem auto' }}
        loading="lazy"
      />
    </header>
  );
}

export default Header;
